export enum FeedbackTypeEnum {
  BugError = 'BugError',
  ExistingFeatureImprovement = 'ExistingFeatureImprovement',
  NewFeatureRequestSuggestion = 'NewFeatureRequestSuggestion',
  NewDocumentResourceAdditionRequest = 'NewDocumentResourceAdditionRequest',
  OtherGeneralFeedback = 'OtherGeneralFeedback',
}

export interface AppFeedbackRequestData {
  feedback_type: FeedbackTypeEnum
  rate_description: string;
  rate_attachment_url: string[];
  device_type: string;
  browser_version: string;
  organisation_id: string | null;
  submission_location: string;
}

export interface UploadedFile {
  filename: string;
  url: string;
}

export interface UploadFeedbackFile {
  file: File;
}
